var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSendRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "mask0_118_4347",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 20,
  height: 20
}, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  fill: "#D9D9D9"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_118_4347)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.72018 16.3578C3.34216 16.5299 2.98346 16.5032 2.64407 16.2776C2.3047 16.0521 2.13501 15.7325 2.13501 15.3188V12.914C2.13501 12.6646 2.2117 12.4419 2.36509 12.2459C2.51848 12.05 2.71595 11.9124 2.95749 11.8333L9.42672 9.99999L2.95749 8.16663C2.71595 8.08754 2.51848 7.95001 2.36509 7.75405C2.2117 7.55809 2.13501 7.33541 2.13501 7.08601V4.68115C2.13501 4.2675 2.3047 3.9479 2.64407 3.72234C2.98346 3.4968 3.34216 3.47008 3.72018 3.6422L16.3108 8.9402C16.7739 9.14007 17.0055 9.49333 17.0055 9.99999C17.0055 10.5066 16.7739 10.8599 16.3108 11.0598L3.72018 16.3578Z",
  fill: "currentColor"
}))));
export default SvgSendRight;